var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOptions = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_639",
    width: 18.882,
    height: 4.196,
    viewBox: "0 0 18.882 4.196",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#007dc3}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 2.098,
    cy: 2.098,
    r: 2.098,
    className: "cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    cx: 2.098,
    cy: 2.098,
    r: 2.098,
    className: "cls-1",
    transform: "translate(7.343)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-3",
    cx: 2.098,
    cy: 2.098,
    r: 2.098,
    className: "cls-1",
    transform: "translate(14.686)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOptions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/options.aa63c021.svg";
export { ForwardRef as ReactComponent };